module.exports = __webpack_public_path__ + "img/Akhmad.fd620ea.png";